import React from 'react';
import { Link } from 'react-router-dom';
import { Shield, FileText, Cookie } from 'lucide-react';
import { Card, CardContent } from '../components/ui/card';
import { Button } from '../components/ui/button';

const Legal = () => {
  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const policies = [
    {
      icon: Shield,
      title: "Privacy Policy",
      description: "How we protect your data",
      link: "/privacy-policy",
      buttonText: "Read Policy"
    },
    {
      icon: FileText,
      title: "Terms of Service",
      description: "Our working agreement",
      link: "/terms-of-service",
      buttonText: "Read Terms"
    },
    {
      icon: Cookie,
      title: "Cookie Policy",
      description: "How we use cookies",
      link: "/cookie-policy",
      buttonText: "Read Policy"
    }
  ];

  return (
    <div className="min-h-screen bg-black text-white">
      {/* Hero Section */}
      <section className="py-20 border-b border-gray-800">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold mb-6">
            Legal & Policies
          </h1>
          <p className="text-xl text-gray-400 max-w-3xl mx-auto">
            Transparency in everything we do
          </p>
        </div>
      </section>

      {/* Policy Cards */}
      <section className="py-20">
        <div className="max-w-7xl mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {policies.map((policy, index) => {
              const IconComponent = policy.icon;
              return (
                <Card 
                  key={index}
                  className="bg-gray-900 border-2 border-gray-800 hover:border-red-500/30 transition-all duration-300 group"
                >
                  <CardContent className="p-8 flex flex-col items-center text-center h-full">
                    {/* Icon */}
                    <div className="w-16 h-16 bg-red-500/10 rounded-full flex items-center justify-center mb-6 group-hover:bg-red-500/20 transition-colors">
                      <IconComponent className="w-8 h-8 text-red-500" />
                    </div>

                    {/* Title */}
                    <h3 className="text-2xl font-bold text-white mb-3">
                      {policy.title}
                    </h3>

                    {/* Description */}
                    <p className="text-gray-400 mb-8 flex-grow">
                      {policy.description}
                    </p>

                    {/* Button */}
                    <Link to={policy.link} onClick={scrollToTop} className="w-full">
                      <Button className="w-full bg-transparent border-2 border-red-500 text-red-500 hover:bg-red-500 hover:text-white transition-all">
                        {policy.buttonText}
                      </Button>
                    </Link>
                  </CardContent>
                </Card>
              );
            })}
          </div>
        </div>
      </section>

      {/* Additional Info Section */}
      <section className="py-16 border-t border-gray-800">
        <div className="max-w-4xl mx-auto px-6 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">
            Questions About Our Policies?
          </h2>
          <p className="text-gray-400 mb-8 max-w-2xl mx-auto">
            We're committed to transparency and protecting your privacy. If you have any questions about our policies, we're here to help.
          </p>
          <Link to="/contact" onClick={scrollToTop}>
            <Button className="btn-primary">
              Contact Us
            </Button>
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Legal;
